import React from "react"

// Types
import { IIconProps } from "./Icon"

const TelephoneIcon: React.FCS<IIconProps> = ({
  className,
  width,
  height,
  color,
}) => (
  <svg
    width="32"
    height="32"
    style={{
      width: `${String(width)}px`,
      height: `${String(height)}px`,
    }}
    className={className}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.30797 2.6561C7.1899 2.50422 7.04087 2.37921 6.87077 2.28935C6.70067 2.1995 6.5134 2.14686 6.3214 2.13495C6.1294 2.12303 5.93706 2.1521 5.75716 2.22023C5.57726 2.28836 5.41391 2.39399 5.27797 2.5301L3.20997 4.6001C2.24397 5.5681 1.88797 6.9381 2.30997 8.1401C4.06343 13.1143 6.91227 17.6309 10.646 21.3561C14.3711 25.0898 18.8877 27.9386 23.862 29.6921C25.064 30.1141 26.434 29.7581 27.402 28.7921L29.47 26.7241C29.6061 26.5882 29.7117 26.4248 29.7798 26.2449C29.848 26.065 29.877 25.8727 29.8651 25.6807C29.8532 25.4887 29.8006 25.3014 29.7107 25.1313C29.6209 24.9612 29.4958 24.8122 29.344 24.6941L24.73 21.1061C24.5676 20.9805 24.3788 20.8933 24.1779 20.8511C23.9771 20.8088 23.7692 20.8126 23.57 20.8621L19.19 21.9561C18.6053 22.1012 17.993 22.093 17.4125 21.9322C16.8319 21.7713 16.3026 21.4634 15.876 21.0381L10.964 16.1241C10.5383 15.6976 10.23 15.1685 10.0688 14.5879C9.90765 14.0073 9.89909 13.395 10.044 12.8101L11.14 8.4301C11.1895 8.23087 11.1933 8.02302 11.151 7.82212C11.1087 7.62122 11.0216 7.4325 10.896 7.2701L7.30797 2.6561ZM3.76797 1.0221C4.11795 0.672001 4.53842 0.400362 5.00144 0.225224C5.46447 0.0500859 5.95945 -0.0245448 6.45353 0.00628779C6.94761 0.0371204 7.42947 0.172711 7.86713 0.404055C8.30478 0.6354 8.68822 0.957205 8.99197 1.3481L12.58 5.9601C13.238 6.8061 13.47 7.9081 13.21 8.9481L12.116 13.3281C12.0598 13.555 12.0631 13.7925 12.1254 14.0178C12.1878 14.243 12.3071 14.4484 12.472 14.6141L17.386 19.5281C17.5519 19.6933 17.7576 19.8128 17.9832 19.8752C18.2089 19.9376 18.4468 19.9406 18.674 19.8841L23.052 18.7901C23.5653 18.6625 24.1008 18.6529 24.6183 18.762C25.1358 18.8712 25.6219 19.0961 26.04 19.4201L30.652 23.0081C32.31 24.2981 32.462 26.7481 30.978 28.2301L28.91 30.2981C27.43 31.7781 25.218 32.4281 23.156 31.7021C17.8773 29.8473 13.085 26.8256 9.13597 22.8621C5.17271 18.9136 2.15107 14.122 0.295965 8.8441C-0.428035 6.7841 0.221965 4.5701 1.70197 3.0901L3.76797 1.0221Z"
      fill={color}
    />
  </svg>
)

export default TelephoneIcon
